import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function PcfgAstarComplete() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Complete:</div>
        <div className='middle-rule-part'>
            <div
                className='antecedence'><span className={'unbreakable'}>x1 + out(B, i, j − i, n − j) : [B, i, j],</span>&nbsp;
                <span className={'unbreakable'}>x2 + out(C, j, k − j, n − k) : [C, j, k]</span>
            </div>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>x1 + x2 + |log(p)| + out(A, i, k − i, n − k) : [A, i, k]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>p : A → B C</span></div>
    </div>)
}
